import { Align } from "src/app/core/enums/align.enum";
import { DataType } from "src/app/core/enums/datatype.enum";
import { Metadata } from "src/app/core/list/metadata/metadata.component";
import { StatusExecucao } from "./status-execucao.enum";

export class CfgIntegracaoEventoLogMetadata {

  static getMetadata(exibirChaveDoEvento: boolean): Metadata[] {
    return [
        {
          fieldId: 'id',
          fieldName: 'Id',
          align: Align.RIGHT,
          dataType: DataType.NUMBER
        }
        , {
          fieldId: 'dataAlteracao',
          fieldName: 'Data',
          title: 'Data de alteração',
          align: Align.CENTER,
          dataType: DataType.DATETIME
        }
        , {
          fieldId: 'cfgIntegracaoEvento.nome',
          fieldName: 'Evento',
          align: Align.CENTER,
          hidden: !exibirChaveDoEvento,
          dataType: DataType.TEXT
        }
        , {
          fieldId: 'statusExecucao',
          fieldName: 'Status',
          align: Align.CENTER,
          dataType: DataType.HTML,
          fnValorCelula: function(data: any) {
            let cssClass = '';
            switch (data.statusExecucao) {
              case StatusExecucao.INICIADO:
                cssClass = 'tag tag-warning lista-tag';
                break;

              case StatusExecucao.PENDENTE:
                cssClass = 'tag tag-warning lista-tag';
                break;

              case StatusExecucao.FINALIZADO_COM_ERRO:
                cssClass = 'tag tag-danger lista-tag';
                break;

              case StatusExecucao.FINALIZADO_COM_SUCESSO:
                cssClass = 'tag tag-success lista-tag';
                break;
            }

            return `<label class='${cssClass}'>${data.statusExecucao}</label>`;
          }
        }
        , {
          fieldId: 'log',
          fieldName: 'Log',
          dataType: DataType.HTML
        }
      ];
  }

}
